export const ContactVariables = {
    zutoContactNumber: '01625 619 944'
}